import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Edit2 } from "react-feather";
import type { TaxUnit } from "../../../../../models";
import { TaxUnitEditModal } from "../../TaxUnitModal/TaxUnitEditModal";
import { GenericList } from "../GenericList";
import type { ListRow } from "../GenericListRow";
import { TaxUnitMobileDetails } from "./TaxUnitMobileDetails";
export const DKTaxUnitMobileList: React.FC<{
  taxUnits: TaxUnit[];
  numberOfDonationsLabel: string;
  sumDonationsLabel: string;
  sumTaxDeductionsLabel: string;
}> = t0 => {
  const $ = _c(21);
  const {
    taxUnits,
    numberOfDonationsLabel,
    sumDonationsLabel,
    sumTaxDeductionsLabel
  } = t0;
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedTaxUnit, setSelectedTaxUnit] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "Navn"
    }, {
      label: "Identifikator"
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const headers = t1;
  let t2;
  if ($[1] !== numberOfDonationsLabel || $[2] !== sumDonationsLabel || $[3] !== sumTaxDeductionsLabel || $[4] !== taxUnits) {
    let t3;
    if ($[6] !== numberOfDonationsLabel || $[7] !== sumDonationsLabel || $[8] !== sumTaxDeductionsLabel) {
      t3 = unit => {
        const contextOptions = [{
          label: "Rediger",
          icon: <Edit2 size={16} />
        }];
        return {
          id: unit.id.toString(),
          defaultExpanded: false,
          cells: [{
            value: unit.name
          }, {
            value: unit.ssn
          }],
          contextOptions,
          onContextSelect: (option, element) => {
            if (option === "Rediger") {
              setEditModalOpen(true);
              setSelectedTaxUnit(element);
            }
          },
          details: <TaxUnitMobileDetails taxUnit={unit} numberOfDonationsLabel={numberOfDonationsLabel} sumDonationsLabel={sumDonationsLabel} sumTaxDeductionsLabel={sumTaxDeductionsLabel} />,
          element: unit
        };
      };
      $[6] = numberOfDonationsLabel;
      $[7] = sumDonationsLabel;
      $[8] = sumTaxDeductionsLabel;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = taxUnits.map(t3);
    $[1] = numberOfDonationsLabel;
    $[2] = sumDonationsLabel;
    $[3] = sumTaxDeductionsLabel;
    $[4] = taxUnits;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const rows = t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>Der mangler information for skatteenheden.</div>;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div>{t3}<div>Kontakt os på <a href="mailto: donasjon@giveffektivt.dk">donasjon@giveffektivt.dk</a>.</div></div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const emptyPlaceholder = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [30, 60];
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== rows) {
    t6 = <GenericList title="" headers={headers} rows={rows} emptyPlaceholder={emptyPlaceholder} expandable={true} proportions={t5} />;
    $[13] = rows;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== editModalOpen || $[16] !== selectedTaxUnit) {
    t7 = editModalOpen && selectedTaxUnit && <TaxUnitEditModal open={editModalOpen} initial={selectedTaxUnit} onClose={() => setEditModalOpen(false)} onSuccess={() => setEditModalOpen(false)} onFailure={_temp} />;
    $[15] = editModalOpen;
    $[16] = selectedTaxUnit;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp() {}